export default __webpack_public_path__ + "65581772a10375e1a5d3fb1e0300e4c9.png";